import { Maybe } from "./types/maybe.ts";

export default function last<T>(array: Maybe<T[]>): Maybe<T> {
  return array != null && array.length > 0 ? array[array.length - 1] : null;
}
